import { apiClient } from '../api';

const platformApi = {
  listOrganizations: () =>
    apiClient.get('/api/settings').then(r => [r.data.settings]),
};

export default platformApi;
